import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getDongleAgreementV2,
  pairDongleV2,
  unpairDongleV2,
  createP1DongleAsset,
  updateP1DongleAsset,
} from '../services/DongleAgreementV2Service';

export const useDongleAgreementV2GetDongleAgreementV2 = createDCHook(
  'getDongleAgreementV2',
  collapseDataFromCall(getDongleAgreementV2),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useDongleAgreementV2PairDongleV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(pairDongleV2, 'requestBody', 'data'),
      'data',
      'dongleMacAddress',
      'dongleFirmwareVersion',
      'dongleWifiName',
      'assetId',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['dongleMacAddress', 'dongleFirmwareVersion', 'dongleWifiName', 'assetId'] },
    ],
  },
);

export const useDongleAgreementV2UnpairDongleV2 = createMutationHook(collapseDataFromCall(unpairDongleV2), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useDongleAgreementV2CreateP1DongleAsset = createMutationHook(collapseDataFromCall(createP1DongleAsset), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useDongleAgreementV2UpdateP1DongleAsset = createMutationHook(updateP1DongleAsset, {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: false,
});
